module.exports = __webpack_public_path__ + "img/leg1.853b6e9e.png";